import { createInjectionState } from "@vueuse/core";
import { computed, onUnmounted, ref, useId, watch } from "vue";
import { useLinkEditorStore } from "./linkEditorStore";

const [useProvideLinkEditContext, useLinkEditContext] = createInjectionState(() => {
  const requestSubmitHandler = ref<() => Promise<void> | void>();

  function setSubmitHandler(handler: () => Promise<void> | void) {
    requestSubmitHandler.value = handler;
  }

  function clearSubmitHandler() {
    requestSubmitHandler.value = undefined;
  }

  async function requestSubmit() {
    const handler = requestSubmitHandler.value;
    if (!handler) return;
    await handler();
  }

  const isEditing = computed(() => !!requestSubmitHandler.value);

  const store = useLinkEditorStore();
  const id = useId();

  let stop: () => void;
  onUnmounted(() => {
    stop?.();
  });

  watch(isEditing, isEditingValue => {
    if (isEditingValue) {
      stop = store.observeEditor(id);
    } else {
      stop?.();
    }
  });

  return {
    isEditing,
    setSubmitHandler,
    clearSubmitHandler,
    requestSubmit,
  };
});

export { useLinkEditContext, useProvideLinkEditContext };
